import React from "react";
import SearchPageNavigation from "./SearchPageNavigation";

export type PageNavigation = {
  resTotal: number;
  skip: number;
  limit: number;
  pageNavigationHandle: Function;
  rowsPerPageHandle?: Function;
};

type RenderSingle<T> = (item: T, index: number) => React.ReactNode;

export type SearchResultListProps<T> = {
  renderSingle: RenderSingle<T>;
  results: T[];
  pageNavigation?: PageNavigation;
};

function SearchResultList<T>({
  renderSingle,
  results,
  pageNavigation,
}: SearchResultListProps<T>) {
  return (
    <>
      {pageNavigation && <SearchPageNavigation {...pageNavigation} />}
      {results.length > 0 &&
        results.map((result: T, ind: number) => {
          return renderSingle(result, ind);
        })}
      {pageNavigation && <SearchPageNavigation {...pageNavigation} />}
    </>
  );
}

export default SearchResultList;
